import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { withLang } from '../../i18n';
import useTitle from '../../hooks/useTitle';

const SurveyTimeoutPage = ({ translate }) => {
  useTitle(translate('surveyResponseTimeEnd.timeout'));
  return (
    <div className="page-container">
      <h2><Translate id="surveyResponseTimeEnd.timeout" /></h2>
    </div>
  );
};

const { func } = PropTypes;
SurveyTimeoutPage.propTypes = {
  translate: func.isRequired
};

export default withLang(SurveyTimeoutPage);
